import React from 'react';
import { Navigate } from 'react-router';
import { useAuthProvider } from '../contexts/AuthProvider';
import { useIsAuthenticated } from '../hooks/use-is-authenticated';

/**
 * Lets in only the users that are authenticated
 * @param props
 * @returns
 */
export default function AuthenticatedOnlyTemplate(props: { children?: React.ReactNode; redirectTo: string }) {
    const context = useAuthProvider();
    const isAuthenticated = useIsAuthenticated(context);

    if (!context.initialized) {
        return <></>;
    }

    if (isAuthenticated) {
        return <>{props.children}</>;
    }

    return <Navigate to={props.redirectTo} replace />;
}
